interface FormChromeFields {
    form_kicker?: string | null;
    form_caption?: string | null;
    copyright_info?: string | null;
    form_instructions?: string | null;
    instructions_before_start?: boolean | null;
    title_align?: string | null;
    show_cover_metrics?: boolean | null;
    show_required_marker?: boolean | null;
    uniform_text_size?: boolean | null;
}

export function trimmedField(value: string | null | undefined): string | null {
    const text = value?.trim() ?? "";
    return text.length > 0 ? text : null;
}

/** Public landing. Present when the form has a kicker, a caption, or a copyright line. */
export function formHasPublicCover(form: FormChromeFields | null | undefined): boolean {
    if (!form) return false;
    return Boolean(
        trimmedField(form.form_kicker) || trimmedField(form.form_caption) || trimmedField(form.copyright_info)
    );
}

/**
 * Instructions appear in one place.
 * Before start: a screen inside the form.
 * Otherwise on the public cover when the form has one, or on the page when it does not.
 */
export function formInstructionsPlacement(
    form: FormChromeFields | null | undefined
): "none" | "intro" | "cover" | "page" {
    if (!trimmedField(form?.form_instructions)) return "none";
    if (form?.instructions_before_start === true) return "intro";
    if (formHasPublicCover(form)) return "cover";
    return "page";
}

/** Title block alignment from forms.title_align. Anything but "center" stays left. */
export function formTitleAlign(form: FormChromeFields | null | undefined): "left" | "center" {
    return form?.title_align === "center" ? "center" : "left";
}

/** Display switches a licensed instrument can turn off. Unset keeps the default look. */
export function formDisplayOptions(form: FormChromeFields | null | undefined) {
    return {
        showCoverMetrics: form?.show_cover_metrics !== false,
        showRequiredMarker: form?.show_required_marker !== false,
        uniformTextSize: form?.uniform_text_size === true,
    };
}

/** A name split before a trailing ©, ® or ™ so the mark can be raised. `mark` is "" when there is none. */
export function splitTrailingMark(name: string): { text: string; mark: string } {
    const match = /^(.*?)\s*([©®™])$/su.exec(name);
    return match ? { text: match[1], mark: match[2] } : { text: name, mark: "" };
}
